import { render, staticRenderFns } from "./AppVideoPlayer.vue?vue&type=template&id=ccdf347c&scoped=true&"
import script from "./AppVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./AppVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./AppVideoPlayer.vue?vue&type=style&index=0&id=ccdf347c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccdf347c",
  null
  
)

export default component.exports